<template>
  <div v-scroll="onScroll" v-if="post" class="portfolio">
    <div class="portfolio__body">
      <div class="portfolio__desc">
        <h1 class="portfolio__title" v-html="splitLetters(post.title.rendered)">
        </h1>
        <div class="portfolio__desc-words" v-html="post.acf.desc"></div>
        <div v-if="!post.acf.video" class="portfolio__triggers">
          <button class="portfolio__triggers-el" @click="changeLayout('grid')">
            <iconGrid  class="icon"/>
          </button>
          <button class="portfolio__triggers-el" @click="changeLayout('scroll')">
            <iconScroll class="icon"/>
          </button>
        </div>
      </div>
      <div v-if="post.acf.video" class="portfolio__video">
        <div class="portfolio__video-wrapper" :style="'background-image: url('+post.acf.video_bg.url+');'">
          <iframe class="portfolio__video-el" :src="'https://www.youtube.com/embed/'+post.acf['id-youtube']+'?rel=0&amp;controls=0&amp;showinfo=1;modestbranding=0;fs=1'" allowfullscreen frameborder="0"></iframe>
          <div class="portfolio__video-overlay" @click="playVideo">
            <button class="portfolio__video-btn">
              <iconPlay class="icon"/>
            </button>
          </div>
        </div>
      </div>
      <ul v-if="post.acf.photos" class="portfolio__photos">
        <li v-for="(photo,index) in post.acf.photos" v-bind:key="index" :class="[photo.big ? 'col-md-8 bigger' : 'col-md-4', 'col-sm-12 portfolio__photos-el']">
          <progressive-img class="portfolio__photos-img" :src="photo.photo.url" alt=""/>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { TweenMax } from 'gsap'
import iconScroll from '../assets/scroll.svg'
import iconGrid from '../assets/grid.svg'
import iconPlay from '../assets/play.svg'

const BASE_URL = process.env.BASE_URL

export default {
  name: 'Portfolio',
  components: {
    iconScroll,
    iconGrid,
    iconPlay
  },
  data () {
    return {
      post: null,
      scrolled: false,
      offsetTop: 0,
      photos: [],
      windowY: '',
      delayAnimation: 0,
      newGrid: null,
      mainTop: null,
      layout: 'grid',
      routeName: this.$route.name
    }
  },
  created: function () {
    this.getPosts()
    window.addEventListener('scroll', this.handleScroll)
  },
  updated () {
    // console.log()
    let headlineLetters = document.querySelector('.portfolio__title').childNodes
    this.animateLetters(headlineLetters, 300, 1, true, document.querySelector('.portfolio__title'), 0.7, 0)

    // TweenMax.set('.portfolio__desc', {perspective: 400})
    let contentPortfolio = document.querySelector('.portfolio__desc-words')
    let contentPortfolioChars = this.splitWords(contentPortfolio.innerText)

    contentPortfolio.innerHTML = contentPortfolioChars
    this.animateLetters(contentPortfolio.childNodes, 1200, 1, true, document.querySelector('.portfolio__desc'), 1.2, 1.2, true)
  },
  mounted: () => {
  },
  watch: {
    windowY: function () {
      // console.log(this.windowY)
      let photos = document.querySelectorAll('.portfolio__photos-img')
      // console.log(photos)
      photos.forEach((element, index) => {
        if (element.getBoundingClientRect().top < (this.windowY + (window.innerHeight / 5))) {
          // console.log(index)
          this.animatePhotos(index, element)
          // }
        }
      })
    }
  },
  methods: {
    getPosts () {
      let url = BASE_URL + `/wp-json/wp/v2/portfolio/?slug=${this.$route.params['slug']}&status=publish`

      axios
        .get(url)
        .then(res => {
          this.post = res.data[0]
           if (res.data[0].acf.photos.length > 0) {
            for (let index = 0; index < res.data[0].acf.photos.length; index++) {
              this.photos[index] = { animated: false }
            }
          }
          if (res.data[0].acf['other-bg'].length > 0) {
            TweenMax.staggerTo(
              'body',
              2,
              { backgroundColor: res.data[0].acf['other-bg'], color: res.data[0].acf['text-color'] },
              0.5
            )
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    isInViewport (element) {
      let rect = element.getBoundingClientRect()
      let html = document.documentElement
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || html.clientHeight) &&
        rect.right <= (window.innerWidth || html.clientWidth)
      )
    },
    handleScroll () {
      // console.log('troll')
      this.windowY = window.scrollY
    },
    onScroll () {
      window.addEventListener('scroll', this.handleScroll)
    },
    visibilityChanged (isVisible, entry, index) {
      let animatePhotos = document.querySelectorAll('.portfolio__photos-img')
      if (isVisible && !this.photos[index].animated) {
        TweenMax.staggerFrom(
          [animatePhotos[index]],
          2,
          {
            // opacity: 0,
            opacity: 0,
            y: 100,
            rotationX: 5,
            // transformPerspective: 300,
            // rotationY: 20,
            rotationZ: 0.5,

            transformOrigin: 'center 120% 0',
            scale: 1.1,
            delay: 1.2
          }
        )
        console.log('anime')
        this.photos[index].animated = true
      }
    },
    imageCheck (index) {
      // console.log(arguments)
      this.photos[index] = { loaded: true, animated: false }
      this.post.acf.photos[index].loaded = true
    },
    splitLetters (title) {
      return title.replace(/([\S^a-z])|\w/g, "<span class='letter'>$&</span>")
    },
    splitWords (content) {
      return content.replace(/[A-Za-zżźćńółęąśŻŹĆĄŚĘŁÓŃ.,!?]+/gu, "<span class='letter'>$&</span>")
    },
    animateLetters (letters, timeoutDuration, letterDuration, animateParent, parent, parentDelay, parentDelay2, complete) {
      if (animateParent) {
        setTimeout(() => {
          TweenMax.staggerTo(
            [parent],
            0.5,
            {
              opacity: 1,
              // y: 20,
              delay: parentDelay
            }
          )
        }, parentDelay2)
      }
      setTimeout(() => {
        letters.forEach((element, index) => {
        // console.log(element)
          TweenMax.staggerFrom(
            [element],
            letterDuration,
            {
              // rotation: 40,
              // x: 10,
              opacity: 0,
              y: 20,
              delay: index * (1 / letters.length),
              onComplete: () => {
                if (complete && (element.length === index)) {
                  // console.log('anime')
                  let triggers = document.querySelector('.portfolio__triggers')
                  TweenMax.staggerTo(
                    [triggers],
                    0.8,
                    {
                      opacity: 1,
                      y: -20
                    }
                  )
                  // this.animatePhotos(0)
                  // this.animatePhotos(1)
                  // if ( element = document.querySelectorAll('.portfolio__photos-img')[2] )
                  let photos = document.querySelectorAll('.portfolio__photos-img')
                  // console.log(photos)
                  photos.forEach((element, index) => {
                    if (element.getBoundingClientRect().top < window.innerHeight) {
                      this.animatePhotos(index, element)
                    }
                  })
                }
              }
            }
          )
        })
      }, timeoutDuration)
    },
    animatePhotos (index, element) {
      if (!element) {
        element = document.querySelectorAll('.portfolio__photos-img')[index]
      }
      if (!this.photos[index].animated) {
        TweenMax.staggerFromTo(
          [element],
          2,
          {
            opacity: 0,
            y: 100,
            rotationX: 5,
            rotationZ: 0.5,
            scale: 1.1
          },
          {
            opacity: 1,
            y: 0,
            rotationX: 0,
            rotationZ: 0,
            scale: 1,
            delay: 0.6 + this.delayAnimation,
            onComplete: () => {
              this.delayAnimation -= 0.6
            }
          }
        )
        this.delayAnimation += 0.6
        // console.log('anime')
        this.photos[index].animated = true
      }
    },
    changeLayout (variant) {
      // console.log('troll')
      let container = document.querySelector('.portfolio__body')
      container.classList.add('grid')
      let layoutPortfolio = document.querySelector('.portfolio__body')
      let layoutDesc = document.querySelector('.portfolio__desc')
      let layoutPhotos = document.querySelector('.portfolio__photos')
      this.layout = variant
      // let movePhotos = layoutDesc.innerHeight
      if (variant === 'scroll') {
        this.mainTop = layoutDesc.clientHeight + 'px'
        console.log(layoutDesc.clientHeight)
        layoutPhotos.style.top = layoutDesc.clientHeight + 'px'
        layoutPhotos.style.left = layoutPhotos.offsetLeft
        layoutPhotos.style.position = 'absolute'
        TweenMax.staggerTo(
          [layoutDesc],
          0.4,
          {
            left: 45,
            // right: '50%',
            width: '45%',
            // textAlign: 'left',
            position: 'fixed',
            onComplete: () => {
              layoutDesc.style.textAlign = 'left'
            }
          }
        )
        TweenMax.staggerTo(
          [layoutPhotos],
          0.4,
          {
            left: (layoutPortfolio.offsetWidth / 2),
            top: 0,
            width: '50%'
          }
        )
      } else {
        TweenMax.staggerTo(
          [layoutDesc],
          0.4,
          {
            left: (layoutPortfolio.clientWidth * 2 / 12),
            // right: '50%',
            width: (8 / 12 * 100) + '%',
            // textAlign: 'left',
            position: 'relative',
            onComplete: () => {
              layoutDesc.style.textAlign = 'center'
            }
          }
        )
        TweenMax.staggerTo(
          [layoutPhotos],
          0.4,
          {
            left: 0,
            top: this.mainTop,
            width: '100%'
          }
        )
      }
    },
    playVideo (event) {
      let video = document.querySelector('iframe')
      let videoURL = video.getAttribute('src')
      video.setAttribute('src', videoURL + '&autoplay=1')
      video.style.opacity = 1
      event.target.classList.toggle('off')
      setTimeout(() => {
        document.querySelector('.portfolio__video-wrapper').style.background = 'none'
      }, 600)
    },
    turnOffVideo () {
      console.log('click')
      document.querySelector('.portfolio__video-btn').classList.toggle('off')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Portfolio.vue